<template>
  <div class="cloud-floor-components" :class="{'link-bg': (type && blueBG)}">
    <div class="floor-mark" v-if="blueBG">
      <img :src="require(`@/assets/images/cloud/floor-mark-${blueBG}.png`)" alt="" class="image">
    </div>
    <div class="floor-title">{{floor.storeyName}}</div>
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'CloudFloor',
  props: {
    floor: {
      type: Object,
      default: null,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    type () {
      return this.floor && this.floor.fixedStoreyResourceEntityList && this.floor.fixedStoreyResourceEntityList.length > 0
    },
    blueBG () {
      if (this.index % 2 !== 0) {
        return (this.index + 1) % 4 === 0 ? 'green' : 'blue'
      } else {
        return ''
      }
    },
  },
}
</script>

<style lang="scss">
.cloud-floor-components {
  position: relative;
  margin: 0 auto;
  width: 1200px;
  padding: 56px 0 46px 0;

  .floor-mark {
    position: absolute;
    top: 74px;
    left: 525px;
    width: 24px;
    height: 24px;

    .image {
      width: 100%;
      height: 100%;
    }
  }

  .floor-title {
    position: relative;
    text-align: center;
    width: 100%;
    font-size: 32px;
    font-weight: bold;
    color: $--color-text-primary;
    z-index: 1;
  }

  &.link-bg {
    background-image: url("../../assets/images/cloud/floor-link-bg.png");
    background-repeat: no-repeat;
    background-position: center top;
    background-size: 80% 100%;
  }
}
</style>
